import { Injectable } from '@angular/core';
import { ConfirmComponent } from '../components/confirm/confirm.component';

@Injectable()
export class ConfirmService {

	private confirms: ConfirmComponent[] = [];
	private enabledConfirms: ConfirmComponent[] = [];

	constructor() { }

	public get activa() {
		return this.enabledConfirms.length > 0 ? this.enabledConfirms[this.enabledConfirms.length - 1] : undefined;
	}

	add(confirm: ConfirmComponent) {
		// add confirm to array of active confirms
		this.confirms.push(confirm);
	}

	remove(id: string) {
		// remove confirm from array of active confirms
		this.confirms = this.confirms.filter(x => x.id !== id);
	}

	open(id: string) {
		const confirm: ConfirmComponent = this.confirms.filter(x => x.id === id)[0];
		// Si existen confirmes habilitadas
		if (this.enabledConfirms.length > 0) {
			// Cerramos la anterior
			this.enabledConfirms[this.enabledConfirms.length - 1].close();
		}
		if (this.enabledConfirms.indexOf(confirm) === -1) {
			// Agregamos la nueva
			this.enabledConfirms.push(confirm);
		}
		// Abrimos la nueva
		confirm.open();
	}

	closeById(id: string) {
		// Cerrar confirm por ID, la activa es la ultima del array
		const confirm: ConfirmComponent = this.confirms.filter(x => x.id === id)[0];
		confirm.close();
		this.enabledConfirms.pop();
		if (this.enabledConfirms.length > 0) {
			// Si queda alguna confirm en el array, la abrimos
			this.open(this.enabledConfirms[this.enabledConfirms.length - 1].id);
		}
	}

	accept(id){
		const confirm: ConfirmComponent = this.confirms.filter(x => x.id === id)[0];
		confirm.accept.emit();
		this.closeById(id);		
	}

	cancel(id){
		const confirm: ConfirmComponent = this.confirms.filter(x => x.id === id)[0];
		confirm.cancel.emit();
		this.closeById(id);
	}	

	close() {
		this.closeById(this.enabledConfirms[this.enabledConfirms.length - 1].id);
	}
}
